import { useContext } from 'react';
import BackdropContext from './RefetchContext';

export default () => useContext(BackdropContext);
